var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 14H8.16667C8.16667 11.2152 9.27291 8.54451 11.242 6.57538C13.2112 4.60625 15.8819 3.5 18.6667 3.5V5.83333C14.1517 5.83333 10.5 9.485 10.5 14ZM18.6667 10.5V8.16667C15.4467 8.16667 12.8333 10.78 12.8333 14H15.1667C15.1667 12.0633 16.73 10.5 18.6667 10.5ZM5.83333 2.33333C5.83333 1.03833 4.795 0 3.5 0C2.205 0 1.16667 1.03833 1.16667 2.33333C1.16667 3.62833 2.205 4.66667 3.5 4.66667C4.795 4.66667 5.83333 3.62833 5.83333 2.33333ZM11.025 2.91667H8.69167C8.55628 3.73164 8.13604 4.47211 7.50578 5.00623C6.87552 5.54035 6.07614 5.83345 5.25 5.83333H1.75C0.781667 5.83333 0 6.615 0 7.58333V10.5H7V7.86333C8.08095 7.52244 9.03829 6.87221 9.75364 5.99305C10.469 5.11389 10.911 4.04435 11.025 2.91667V2.91667ZM19.8333 17.5C21.1283 17.5 22.1667 16.4617 22.1667 15.1667C22.1667 13.8717 21.1283 12.8333 19.8333 12.8333C18.5383 12.8333 17.5 13.8717 17.5 15.1667C17.5 16.4617 18.5383 17.5 19.8333 17.5ZM21.5833 18.6667H18.0833C17.2572 18.6668 16.4578 18.3737 15.8276 17.8396C15.1973 17.3054 14.7771 16.565 14.6417 15.75H12.3083C12.4223 16.8777 12.8643 17.9472 13.5797 18.8264C14.295 19.7055 15.2524 20.3558 16.3333 20.6967V23.3333H23.3333V20.4167C23.3333 19.4483 22.5517 18.6667 21.5833 18.6667Z",
    fill: "",
    fillOpacity: 0.86
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactus);
export default __webpack_public_path__ + "static/media/contactus.2b3789362ffab45a39a06ce02a20b593.svg";
export { ForwardRef as ReactComponent };